import React, { useState, useCallback } from 'react';
import { Share2, Link, Copy, Check } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const RARITY_COLORS = {
  common: '#9CA3AF', rare: '#3B82F6', epic: '#8B5CF6', legendary: '#F59E0B',
};

const ShareCollectible = ({ collectibleId, title, rarity, onClose }) => {
  const [shareData, setShareData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const loadShare = useCallback(async () => {
    if (shareData) return;
    setLoading(true);
    try {
      const resp = await fetch(`${API_URL}/api/engagement/share/${collectibleId}`);
      const data = await resp.json();
      setShareData(data);
    } catch {}
    setLoading(false);
  }, [collectibleId, shareData]);

  React.useEffect(() => { loadShare(); }, [loadShare]);

  const copyLink = () => {
    if (shareData?.share_url) {
      navigator.clipboard.writeText(shareData.share_url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const shareTwitter = () => {
    const text = encodeURIComponent(shareData?.share_text || `Check out my HiBFF collectible!`);
    const url = encodeURIComponent(shareData?.share_url || '');
    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, '_blank');
  };

  const shareWhatsApp = () => {
    const text = encodeURIComponent(`${shareData?.share_text || ''} ${shareData?.share_url || ''}`);
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  if (loading) return <p className="text-xs text-gray-400 text-center py-4">Loading...</p>;

  return (
    <div className="space-y-3" data-testid="share-collectible">
      <div className="flex items-center gap-2 mb-2">
        <Share2 size={16} className="text-purple-500" />
        <p className="text-sm font-semibold text-gray-900">Share this collectible</p>
        {rarity && (
          <span className="px-2 py-0.5 rounded text-[10px] font-bold text-white" style={{ backgroundColor: RARITY_COLORS[rarity] || '#999' }}>
            {rarity?.toUpperCase()}
          </span>
        )}
      </div>

      <div className="flex gap-2">
        <button onClick={shareTwitter} className="flex-1 py-2.5 rounded-lg bg-black text-white text-xs font-semibold hover:bg-gray-800 transition-colors">
          X / Twitter
        </button>
        <button onClick={shareWhatsApp} className="flex-1 py-2.5 rounded-lg bg-green-600 text-white text-xs font-semibold hover:bg-green-700 transition-colors">
          WhatsApp
        </button>
        <button onClick={copyLink} className="flex-1 py-2.5 rounded-lg bg-gray-100 text-gray-700 text-xs font-semibold hover:bg-gray-200 transition-colors flex items-center justify-center gap-1">
          {copied ? <><Check size={14} /> Copied!</> : <><Copy size={14} /> Copy Link</>}
        </button>
      </div>
    </div>
  );
};

export default ShareCollectible;
